import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';

interface HeroTitleProps {
  className?: string;
  delay?: number;
}

export function HeroTitle({
  className = "",
  delay = 0
}: HeroTitleProps) {
  const { t } = useLanguage();

  const part1 = t('hero.buildAgentsBlur');
  const part2 = t('hero.buildAgentsSuffix');

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: delay
      }
    }
  };

  // Standard animations for all characters
  const charVariants: any = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100
      }
    }
  };

  return (
    <div className="group/animated-title w-fit mx-auto relative cursor-default">
      <motion.h2
        className={`relative z-10 font-light tracking-tight text-[color:var(--foreground)] ${className}`}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        {/* Part 1 (Confidencialidade - Privacy Blur Effect) */}
        <span
          className="inline-block"
        >
          {part1.split('').map((char, index) => (
            <motion.span
              key={`p1-${index}`}
              variants={charVariants}
              className="inline-block"
            >
              {char === ' ' ? '\u00A0' : char}
            </motion.span>
          ))}
        </span>

        {/* Part 2 (Normal) */}
        {part2.split('').map((char, index) => (
          <motion.span
            key={`p2-${index}`}
            variants={charVariants}
            className="inline-block"
          >
            {char === ' ' ? '\u00A0' : char}
          </motion.span>
        ))}
      </motion.h2>
    </div>
  );
}
